import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as CommonActions from '../../common/actions';
import * as Util from '../../common/utilities';

import { ToastContainer } from '@salesforce/design-system-react';

import { ApiErrorToast } from '../components';

import './ApiErrorToastContainer.scss';

export class ApiErrorToastContainer extends Component {
  componentDidUpdate(prevProps) {
    // check for a new error
    if (
      Util.propChanged(prevProps, this.props, 'error.timestamp') &&
      !this.props.toast.isOpen
    ) {
      this.props.actions.closeToast('apiError');
      this.props.actions.openToast('apiError', this.props.error.error);
    }
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer className="toast-container">
          <ApiErrorToast
            onRequestClose={() => this.props.actions.closeToast('apiError')}
            error={this.props.toast.apiError}
            i18n={this.props.i18n}
            className="api-error-toast"
          />
        </ToastContainer>
      </React.Fragment>
    );
  }
}

ApiErrorToastContainer.contextTypes = {
  router: PropTypes.object
};

ApiErrorToastContainer.propTypes = {
  error: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    error: state.error,
    i18n: state.i18n,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApiErrorToastContainer);
